import { useEffect, useRef, useState } from "react";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import UserDetails from "../userservice/UserDetails";
import {
  alphabetsRgex,
  mobileNoRegex,
  passwordRegex,
  alphabetsNumDotUnderscoreHyphenRgex,
  alphabetsNumberRegex,
} from "../../../commoncomponents/input/Regex";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import { setUserData } from "../../RegistraionAction";
import {
  postAxios,
  encryptedText,
  getRequest,
} from "../../../../api/AxiosAPICall";
import { Backdrop, CircularProgress, Grid, Typography } from "@mui/material";
import moment from "moment";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useNavigationType } from "react-router-dom";

//This blank array is used for storing service details
let serviceDetailFinalobject: any[] = [];
//This blank array is used for storing service type  details
let serviceDetailTypeFinalobject: any[] = [];
//This blank array is used for storing user  details
let userDetailsFinalObject: any[] = [];

export let userDetailsObject = {
  userId: 0,
  clinicName: "",
  userName: "",
  password: "",
  confirmPassword: "",
  appointment: "Yes",
  title: "",
  givenName: "",
  familyName: "",
  gender: "",
  userEmailId: "",
  userMobile: "",
  mbttNumber: "",
  clinicalUser: false,
  clericalUser: false,
  FinancialUser: false,
  AdministratorUser: false,
  NurseUser: false,
  HpDefaultAppt: true,
};

const UserComponent = () => {
  const [isUserPresent, setIsUserPresent] = useState(false);
  const [isUserEmailPresent, setIsUserEmailPresent] = useState(false);
  const [isUserMobilePresent, setIsUserMobilePresent] = useState(false);

  let history = useNavigate();
  const isMounted = useRef<any>();
  const [open, setOpen] = useState(false);
  let userNamesList: { [key: number]: string } = {};
  let userEmailList: { [key: number]: string } = {};
  let userMobileList: { [key: number]: string } = {};
  const dispatch = useDispatch();
  let navType = useNavigationType();

  const { serviceTypeJson } = useSelector((state: any) => state.serviceType);

  useEffect(() => {
    return () => {
      if (navType === "POP") {
        history("/unauthenticatedUser");
      }
    };
  }, [navType, history]);

  useEffect(() => {
    isMounted.current = true;
    if (
      serviceTypeJson === undefined ||
      serviceTypeJson === "" ||
      serviceTypeJson === null
    ) {
      history("/organization");
    }
    return () => {
      isMounted.current = false;
    };
  }, [serviceTypeJson, history]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);
  const alertUser = (e: any) => {
    e.preventDefault();
    e.returnValue = "";
  };

  const getUserData = async (userDetailsJson: any) => {
    let finalUserDetailsJson = { userDetails: userDetailsJson };
    let registerUser;
    if (
      serviceTypeJson !== undefined ||
      serviceTypeJson !== null ||
      serviceTypeJson !== ""
    ) {
      registerUser = { ...serviceTypeJson, ...finalUserDetailsJson };
    }

    const generateServiceObject = (value: any) => {
      value?.forEach((element: any) => {
        let newData = {
          cliName: element.clinicName,
          cliAdditionalServices: element.additionalServices,
          businessHoursJson: {
            cbhMondayStartTime:
              element.monday[0].startTime === "" ||
              element.monday[0].startTime === undefined ||
              element.monday[0].startTime === null
                ? ""
                : moment(element.monday[0].startTime).format("HH:mm") + ":00",

            cbhMondayEndTime:
              element.monday[0].endTime === "" ||
              element.monday[0].endTime === undefined ||
              element.monday[0].endTime === null
                ? ""
                : moment(element.monday[0].endTime).format("HH:mm") + ":00",

            cbhTuesdayStartTime:
              element.tuesday[0].startTime === "" ||
              element.tuesday[0].startTime === undefined ||
              element.tuesday[0].startTime === null
                ? ""
                : moment(element.tuesday[0].startTime).format("HH:mm") + ":00",

            cbhTuesdayEndTime:
              element.tuesday[0].endTime === "" ||
              element.tuesday[0].endTime === undefined ||
              element.tuesday[0].endTime === null
                ? ""
                : moment(element.tuesday[0].endTime).format("HH:mm") + ":00",

            cbhWednesdayStartTime:
              element.wednesday[0].startTime === "" ||
              element.wednesday[0].startTime === undefined ||
              element.wednesday[0].startTime === null
                ? ""
                : moment(element.wednesday[0].startTime).format("HH:mm") +
                  ":00",
            cbhWednesdayEndTime:
              element.wednesday[0].endTime === "" ||
              element.wednesday[0].endTime === undefined ||
              element.wednesday[0].endTime === null
                ? ""
                : moment(element.wednesday[0].endTime).format("HH:mm") + ":00",

            cbhThursdayStartTime:
              element.thursday[0].startTime === "" ||
              element.thursday[0].startTime === undefined ||
              element.thursday[0].startTime === null
                ? ""
                : moment(element.thursday[0].startTime).format("HH:mm") + ":00",

            cbhThursdayEndTime:
              element.thursday[0].endTime === "" ||
              element.thursday[0].endTime === undefined ||
              element.thursday[0].endTime === null
                ? ""
                : moment(element.thursday[0].endTime).format("HH:mm") + ":00",

            cbhFridayStartTime:
              element.friday[0].startTime === "" ||
              element.friday[0].startTime === undefined ||
              element.friday[0].startTime === null
                ? ""
                : moment(element.friday[0].startTime).format("HH:mm") + ":00",

            cbhFridayEndTime:
              element.friday[0].endTime === "" ||
              element.friday[0].endTime === undefined ||
              element.friday[0].endTime === null
                ? ""
                : moment(element.friday[0].endTime).format("HH:mm") + ":00",

            cbhSaturdayStartTime:
              element.saturday[0].startTime === "" ||
              element.saturday[0].startTime === undefined ||
              element.saturday[0].startTime === null
                ? ""
                : moment(element.saturday[0].startTime).format("HH:mm") + ":00",

            cbhSaturdayEndTime:
              element.saturday[0].endTime === "" ||
              element.saturday[0].endTime === undefined ||
              element.saturday[0].endTime === null
                ? ""
                : moment(element.saturday[0].endTime).format("HH:mm") + ":00",

            cbhSundayStartTime:
              element.sunday[0].startTime === "" ||
              element.sunday[0].startTime === undefined ||
              element.sunday[0].startTime === null
                ? ""
                : moment(element.sunday[0].startTime).format("HH:mm") + ":00",

            cbhSundayEndTime:
              element.sunday[0].endTime === "" ||
              element.sunday[0].endTime === undefined ||
              element.sunday[0].endTime === null
                ? ""
                : moment(element.sunday[0].endTime).format("HH:mm") + ":00",
          },
        };

        serviceDetailFinalobject.push(newData);
      });
      return serviceDetailFinalobject;
    };

    //Serivice Type
    const generateServiceTypeObject = (value: any) => {
      value.forEach((element: any) => {
        let newData = {
          cliName: element.clinicName,
          cliType: element.serviceType,
          addressJson: {
            addAddress1: element.numberAndRoad,
            addAddress2: element.serviceDistrict,
            addAddress3: element.townCity,
            addAddress4: element.countyText,
            addAddress5: element.postCode,
            addAddress6: element.country,
            addPhone: element.phoneNumber,
            addMobile: element.mobile,
            addEmail: element.email,
          },
        };

        serviceDetailTypeFinalobject.push(newData);
      });
      return serviceDetailTypeFinalobject;
    };
    // This function is for generating userdetails object

    const generateUserObject = (value: any) => {
      value.forEach((element: any) => {
        let userRoles: any[] = [];
        if (element.clinicalUser === true) {
          userRoles.push("Clinical");
        }

        if (element.clericalUser === true) {
          userRoles.push("Clerical");
        }

        if (element.FinancialUser === true) {
          userRoles.push("Financial");
        }

        if (element.AdministratorUser === true) {
          userRoles.push("Administrator");
        }

        if (element.NurseUser === true) {
          userRoles.push("Nurse");
        }

        if (element.HpDefaultAppt === true) {
          userRoles.push("HP Default Appt");
        }
        let newData = {
          useClinicName: element.clinicName,
          useUsername: element.userName,
          usePassword: encryptedText(element.password), //encrypts the password
          useAppointment: element.appointment,
          useTitle: element.title,
          useFirstname: element.givenName,
          useSurname: element.familyName,
          useGender: element.gender,
          useEmail: element.userEmailId,
          useMobile: element.userMobile,
          eleMbttNumber: element.mbttNumber,
          userRoles: userRoles,
        };

        userDetailsFinalObject.push(newData);
      });
      return userDetailsFinalObject;
    };

    setOpen(true);
    const response = await postAxios(
      "establishment/register",
      {
        estName: registerUser.organizationName,
        estPatientwebAccess: "1",
        estCodePreference: registerUser.identifier,
        estType: registerUser.estType,
        addressJson: {
          addAddress6: registerUser.country,
          addAddress1: registerUser.numberRoad,
          addAddress2: registerUser.district,
          addAddress3: registerUser.town,
          addAddress4: registerUser.county,
          addAddress5: registerUser.postCode,
          addPhone: registerUser.phoneNo,
          addMobile: registerUser.mobile,
          addEmail: registerUser.emailId,
        },
        clinicDetails: generateServiceObject(registerUser.clinicDetails),
        serviceDetails: generateServiceTypeObject(registerUser.serviceDetails),
        userJson: generateUserObject(registerUser.userDetails),
      },
      {}
    );

    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "CellmaFlex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else {
      dispatch(setUserData(response?.data?.usernames));
      setOpen(false);
      dispatch(
        setSnackbar(
          true,
          4000,
          "success",
          "Registration details are saved successfully!",
          "top",
          "center"
        )
      );
      setTimeout(() => {
        history("/hpscheduling");
      }, 2000);
    }
  };

  const CheckDuplicateUser = async (value: any) => {
    await getRequest("checkDuplicateUsername", {
      params: {
        username: value,
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "CellmaFlex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setIsUserPresent(response?.data);
      }
    });
  };

  const CheckDuplicateUserEmail = async (value: any) => {
    await getRequest("checkDuplicateUserEmail", {
      params: {
        email: value,
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "CellmaFlex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setIsUserEmailPresent(response?.data);
      }
    });
  };

  const CheckDuplicateUserMobile = async (value: any) => {
    await getRequest("checkDuplicateUserMobile", {
      params: {
        mobile: value,
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "CellmaFlex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setIsUserMobilePresent(response?.data);
      }
    });
  };

  const formik = useFormik({
    initialValues: userDetailsObject,

    validationSchema: Yup.object({
      clinicName: Yup.string().required("Please select clinic name."),
      userName: Yup.string()
        .min(3, "Username must be more than 3 characters.")
        .max(30, "Username must be under 30 characters.")
        .required("Please enter username.")
        .matches(
          alphabetsNumDotUnderscoreHyphenRgex,
          "Allowed Alphabets, Numbers, Dot, Hyphen and Underscore. First or Last character must not be symbol"
        )
        .test(
          "unique",
          "Cannot have two user with similar username, Please enter unique username",
          async (value: any, context: any) => {
            for (let key in userNamesList) {
              let serviceContextPath = `userDetails[${key}].userName`;
              if (serviceContextPath === context.path.toString()) {
                continue;
              }
              if (
                value !== "" &&
                userNamesList[key] !== "" &&
                value === userNamesList[key]
              ) {
                return false;
              }
            }
            return true;
          }
        ),

      familyName: Yup.string()
        .max(30, "Name must be under 30 characters.")
        .required("Please enter familyname.")
        .matches(alphabetsRgex, "Only Aplhabets allowed."),
      givenName: Yup.string()
        .max(30, "Name must be under 30 characters.")
        .required("Please enter given name.")
        .matches(alphabetsRgex, "Only Aplhabets allowed."),
      userEmailId: Yup.string()
        .email("Enter valid email ")
        .required("Please enter email id.")
        .test(
          "unique",
          "Cannot have two user with similar email, Please enter unique email",
          async (value: any, context: any) => {
            for (let key in userEmailList) {
              let serviceContextPath = `userDetails[${key}].userEmailId`;
              if (serviceContextPath === context.path.toString()) {
                continue;
              }
              if (
                value !== "" &&
                userEmailList[key] !== "" &&
                value === userEmailList[key]
              ) {
                return false;
              }
            }
            return true;
          }
        ),

      password: Yup.string()
        .matches(
          passwordRegex,
          "Password must have minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter and 1 number."
        )
        .required("Please enter password."),
      confirmPassword: Yup.string()
        .min(8, "Password should be longer than 8 characters.")
        .required("Please enter password.")
        .oneOf(
          [Yup.ref("password")],
          "Confirm passwords must match password above."
        ),
      userMobile: Yup.string()
        .matches(mobileNoRegex, "Please enter valid mobile number")
        .required("Please enter mobile number")
        .test(
          "unique",
          "Cannot have two user with similar Mobile number, Please enter unique mobile number",
          async (value: any, context: any) => {
            for (let key in userMobileList) {
              let serviceContextPath = `userDetails[${key}].userMobile`;
              if (serviceContextPath === context.path.toString()) {
                continue;
              }
              if (
                value !== "" &&
                userMobileList[key] !== "" &&
                value === userMobileList[key]
              ) {
                return false;
              }
            }
            return true;
          }
        ),
      mbttNumber: Yup.string()
        .when("title", {
          is: (value: any) => value && (value === "Prof" || value === "Dr"),
          then: () => Yup.string().required("Please enter MBTT number."),
        })
        .matches(alphabetsNumberRegex, "Only alphabets and numbers are allowed")
        .max(10, "MBTT number must be under 10 characters."),
    }),

    onSubmit: () => {},
  });

  return (
    <CommonLayout>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant="h1" className={globalClasses.pageTitle}>
            Register your Organization
          </Typography>
          <Typography
            sx={{
              display: "flex",
              justifyContent: "center",
              margin: "10px",
              color: "#474747",
              fontSize: "14px",
            }}
          >
            Step 1 to step 4 is mandatory in order to complete registration
          </Typography>
        </Grid>
      </Grid>

      <UserDetails
        serviceData={serviceTypeJson}
        sendUserData={getUserData}
        formik={formik}
        checkDuplicateUser={CheckDuplicateUser}
        isUserPresent={isUserPresent}
        CheckDuplicateUserEmail={CheckDuplicateUserEmail}
        isUserEmailPresent={isUserEmailPresent}
        CheckDuplicateUserMobile={CheckDuplicateUserMobile}
        isUserMobilePresent={isUserMobilePresent}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: 1500,
          display: "flex",
          flexDirection: "column",
        }}
        open={open}
      >
        <Typography fontWeight="600" fontSize="20px">
          Registering...!
        </Typography>

        <CircularProgress color="primary" sx={{ margin: "20px" }} />
      </Backdrop>
    </CommonLayout>
  );
};

export default UserComponent;
